<template>
    <div class="index-index-classify">
        <div class="index-classify-selected">
            <div class="index-selected-label">已选择</div>
            <div class="index-selected-list">
                <div class="index-selected-item" v-for="(item,index) in selected" :key="index">
                    {{item.name}}
                    <img src="../../assets/image/sub@2x.png" @click="onCategoryRemove(index)" />
                </div>
            </div>
        </div>
        <div class="index-classify-contain">
            <ul class="index-classify-list">
                <li :class="['index-classify-item', {'select': selecting.cate1 === index}]" v-for="(item,index) in list" :key="index" @click="onCateChoose('cate1',index)">{{item.name}}</li>
            </ul>
            <ul class="index-classify-list">
                <li :class="['index-classify-item', {'select': selecting.cate2 === index}]" v-for="(item,index) in list" :key="index" @click="onCateChoose('cate2',index)">{{item.name}}</li>
            </ul>
            <ul class="index-classify-list">
                <li :class="['index-classify-item', {'select': selecting.cate3 === index}]" v-for="(item,index) in list" :key="index" @click="onCateChoose('cate3',index)">{{item.name}}</li>
            </ul>
        </div>
        <FixedBtn label="提交" @btnClick="btnClick"></FixedBtn>
    </div>
</template>

<script>
import http from "@/utils/axios";
import FixedBtn from "./components/fixed_btn";
export default {
    data() {
        return {
            selected: [
                {
                    name: '箱包手袋1>旅行箱>单间双肩包',
                    id: 1
                },
                {
                    name: '箱包手袋2>旅行箱>单间双肩包',
                    id: 2
                },
                {
                    name: '箱包手袋3>旅行箱>单间双肩包',
                    id: 3
                }
            ],
            list: [
                { name: '全部', id: 1 },
                { name: '潮流包包服饰', id: 2 },
                { name: '轻奢名品', id: 3 },
                { name: '箱包手袋', id: 4 }
            ],
            selecting: {
                cate1: 0,
                cate2: '',
                cate3: ''
            }
        }
    },
    created() {
        this.getCategoryList()
    },
    methods: {
        btnClick() {
            console.log(this.list)
            console.log(this.selected)
        },
        getCategoryList() {
            http({
                url: '/order/bees/discountActivity/goodCategory',
                method: 'post',
                parmes: {
                    discountActivityId: this.$route.query.id,
                    goodType: 1,
                    isInvolved: 'y'
                }
            }).then(rps=>{
                this.$loading.hide()
                if(rps.code == 200) {
                    this.queryData = rps.data
                    this.queryData.startTimeStr = new Date(this.queryData.startTime.replace(/\-/g,'/'))
                    this.queryData.endTimeStr = new Date(this.queryData.endTime.replace(/\-/g,'/'))
                }
            })
        },
        onCategoryRemove(index) {
            this.selected.splice(index, 1)
        },
        onCateChoose(key, index) {
            this.selecting[key] = index
            
            if(key == 'cate3' && (this.selecting.cate2 || this.selecting.cate2===0)) {
                this.selected.push({name: this.list[this.selecting.cate1].name + '>' + this.list[this.selecting.cate2].name + '>' + this.list[this.selecting.cate3].name, })
                this.selecting.cate2 = '';
                this.selecting.cate3 = '';
            }
        }
    },
    components: { FixedBtn }
}
</script>

<style lang="less" scoped>
.index-index-classify {
    // display: flex;
    font-size: 24px;
    .index-classify-selected {
        display: flex;
        background-color: #fff;
        padding: 25px;
        .index-selected-label {
            width: 180px;
            height: 100px;
            margin-right: 10px;
            line-height: 100px;
            text-align: center;
        }
        .index-selected-list {
            .index-selected-item {
                height: 40px;
                position: relative;
                padding: 0 38px;
                line-height: 40px;
                background-color: #F2F2F2;
                color: #999;
                border-radius: 29px;
                margin-top: 20px;
                &:first-child {
                    margin-top: 0;
                }
                img {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    right: -48px;
                }
            }
        }
    }
    .index-classify-contain {
        display: flex;
        background-color: #fff;
        margin-top: 20px;
        .index-classify-list:first-child {
            .select::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                width: 10px;
                height: 100px;
                background-color: #F8A651;
                transform: translateY(-50%);
            }
        }
        .index-classify-list {
            width: 250px;
            .index-classify-item {
                height: 100px;
                line-height: 100px;
                text-align: center;

                &.select {
                    color: #F8A651;
                    background-color: #FFF8F1;
                    position: relative;
                }
            }
        }
    }
}
</style>